import React from 'react'

import useCart from 'store/CartProvider'
import HeaderDropdown from './HeaderDropdown'
import CustomCart from 'components/Icons/customCart'
import HeaderCartItem from 'components/Header/components/HeaderCartItem'

const CartDropdown = ({ open, onClose }) => {
  const { products } = useCart()

  return (
    <HeaderDropdown
      open={open}
      onClose={onClose}
      title="ჩემი კალათა"
      items={products}
      emptyIcon={CustomCart}
      emptyTitle="კალათა ცარიელია"
      emptyMessage="გთხოვთ აირჩიოთ პროდუქცია"
      buttonText="ყიდვა"
      buttonRoute="/purchase"
      rightOffset="-right-6"
      tooltipRightOffset="right-[37px] md:right-[38px]"
      renderItem={product => <HeaderCartItem product={product} />}
    />
  )
}

export default CartDropdown
